import { PostForm } from '../../components/PostForm/PostForm';
import { PageContainer } from '../../containers/PageContainer/PageContainer';
import { Copy } from '../../copy/Copy';

export const Post = () => (
  <PageContainer title={Copy.generate('Global.postToFeed')}>
    <PostForm />
  </PageContainer>
);
